import styled from "styled-components"

const StyledType = styled.div`
  cursor: pointer; 
  min-height: 150px;
  width: 150px;
  min-height: 100px;
  height: 100px;
  max-height: 100px;
  text-align: center;
  vertical-align: middle;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${props => props.theme.main};
  border-radius: 5px;
  user-select: none;
  &:hover {
    background-color: ${props => props.theme.main};
    > h1 {
      color: white;
    }
    > svg {
      color: white;
    }
  }
  h1 {
    color: ${props => props.theme.main};
    font-size: 28px;
  }
`;


interface BigButtonProps {
  text: string;
  onClick: Function;
  customHeight?: string;
  style?: React.CSSProperties;
}

export const BigButton = (props: BigButtonProps) => {
  return (
    <StyledType
      style={props.style}
      onClick={() => props.onClick()}
    >
      <h1>{props.text}</h1>
    </StyledType>
  );
};
